import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, InputBase, IconButton } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useGetDiscountCouponCode } from '../../assets/api/useGetApi';
import useCouponStore from '../../shared/store/useCouponStore';

const ActivityLMSCoupon = ({ courseId, totalPrice }) => {
    const { data: couponCodeList } = useGetDiscountCouponCode({ course_id: courseId });
    const { setCouponData, resetCouponData } = useCouponStore();
    
    const [coupon, setCoupon] = useState("");
    const [isPassed, setIsPassed] = useState(false);
    const [couponInvalid, setCouponInvalid] = useState(false);
    const [showCouponInput, setShowCouponInput] = useState(false);
    const [couponFound, setCouponFound] = useState(null);

    const today = new Date().toISOString().split("T")[0];
    const couponArray = couponCodeList?.data
        ?.filter(item => {
            const startDate = item?.start_date ? item.start_date.split("T")[0] : "";
            const endDate = item?.end_date ? item.end_date.split("T")[0] : "";
            return today >= startDate && today <= endDate && item?.status === 'approved';
        })
        ?.map(item => ({
            coupon: item?.coupon_code,
            price: item?.discount_amount,
            id: item?.id,
        })) || [];

    const computedPrice =
        isPassed && totalPrice >= couponFound?.price
            ? totalPrice - couponFound?.price
            : totalPrice;

    useEffect(() => {
        setCouponData({
            isPassed: isPassed,
            finalPrice: Number(computedPrice),
            discountAmount: isPassed ? couponFound?.price : 0,
            couponCode: isPassed ? couponFound?.coupon : "",
            discountId: isPassed ? couponFound?.id : null,
        });
    }, [computedPrice, isPassed, couponFound]);

    useEffect(() => {
        if (isPassed && totalPrice < couponFound?.price) {
            setIsPassed(false);
            setCouponInvalid(true);
        } else {
            setCouponInvalid(false);
        }
    }, [totalPrice]);

    const handleCheckCouponCode = () => {
        const foundCoupon = couponArray.find(c => c.coupon === coupon);

        if (foundCoupon) {
            if (totalPrice >= foundCoupon?.price) {
                setCouponFound(foundCoupon);
                setIsPassed(true);
                setCouponInvalid(false);
            } else {
                setIsPassed(false);
            }
        } else {
            setIsPassed(false);
            setCouponInvalid(true);
        }
        setCoupon("");
    };

    useEffect(() => {
        return () => resetCouponData();
    }, []);

    return (
        <Box sx={{ mt: 1, mb: 2 }}>
            {isPassed ? (
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        backgroundColor: "rgba(76, 175, 80, 0.1)",
                        borderRadius: "8px",
                        padding: "0.5rem 1rem",
                        width: "100%",
                    }}
                >
                    <Typography variant="body2" color="green" fontWeight={500}>
                        {couponFound?.coupon} applied
                    </Typography>
                    <Button
                        sx={{ fontSize: "12px", fontWeight: 500, color: 'red.main', textTransform: 'none' }}
                        onClick={() => {
                            setIsPassed(false);
                            setCoupon("");
                            setShowCouponInput(false);
                            setCouponInvalid(false);
                        }}
                    >
                        Remove
                    </Button>
                </Box>
            ) : couponInvalid ? (
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        backgroundColor: "rgba(244, 67, 54, 0.1)",
                        borderRadius: "8px",
                        padding: "0.5rem 1rem",
                        width: "100%",
                    }}
                >
                    <Typography variant="body2" color="error" fontWeight={500}>
                        Invalid or Minimum amount required
                    </Typography>
                    <Button
                        sx={{ fontSize: "12px", fontWeight: 500, color: 'red.main', textTransform: 'none' }}
                        onClick={() => {
                            setShowCouponInput(true);
                            setCouponInvalid(false);
                        }}
                    >
                        Retry
                    </Button>
                </Box>
            ) : !showCouponInput ? (
                <Typography
                    variant="body2"
                    color="red.main"
                    sx={{
                        cursor: "pointer",
                        textDecoration: "underline",
                        textAlign: "center",
                    }}
                    onClick={() => setShowCouponInput(true)}
                >
                    Do you have a coupon code?
                </Typography>
            ) : (
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        backgroundColor: "rgba(139, 48, 48, 0.1)",
                        borderRadius: "8px",
                        padding: "0 0.5rem",
                        width: "100%",
                        height: "2.5rem",
                    }}
                >
                    <InputBase
                        placeholder="Enter Coupon Code"
                        sx={{
                            flex: 1,
                            pl: 1,
                            textTransform: "uppercase",
                        }}
                        value={coupon.toUpperCase()}
                        onChange={(e) => setCoupon(e.target.value.toUpperCase())}
                    />
                    <IconButton
                        sx={{
                            backgroundColor: "red.main",
                            color: "#fff",
                            borderRadius: "8px",
                            ml: 1,
                            py: 0.3,
                            px: 1.5,
                            "&:hover": {
                                backgroundColor: "red.main",
                            },
                        }}
                        onClick={handleCheckCouponCode}
                    >
                        <ArrowForwardIcon />
                    </IconButton>
                </Box>
            )}
        </Box>
    );
};

export default ActivityLMSCoupon;